/**
 * Gère la hauteur réelle du viewport pour éviter les problèmes avec 100vh
 * sur les appareils avec barres de navigation
 */
export const setupViewportHeight = () => {
  const setViewportHeight = () => {
    // Obtenir la hauteur réelle du viewport
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    // Gérer aussi pour les petits écrans avec interface utilisateur
    const heightWithoutUI = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty('--vh-no-ui', `${heightWithoutUI}px`);
  };

  // Appeler au chargement
  setViewportHeight();

  // Appeler lors du redimensionnement
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);

  // Appeler lors de l'apparition de l'interface mobile (clavier virtuel)
  window.visualViewport?.addEventListener('resize', setViewportHeight);

  return () => {
    window.removeEventListener('resize', setViewportHeight);
    window.removeEventListener('orientationchange', setViewportHeight);
    window.visualViewport?.removeEventListener('resize', setViewportHeight);
  };
};
